import React, { useState, useContext } from 'react';
import Button from '../../components/@base/Button';
import styles from './ChatbotTesting.module.css';
import Select from '../../components/@base/Select';
import SelectOption from '../../components/@base/SelectOption';
import ChatbotTestingContext from '../../context/ChatbotTestingContext';
import Scrim from '../../components/@base/Scrim';
import Modal from '../../components/@base/Modal';
import Input from '../../components/@base/Input';
import { Validation } from '../../components/BotComponents/Commons';
import DeleteConfirmation from '../../components/DeleteConfirmation/DeleteConfirmation';

export default function ChatbotTestingSuites() {
  const chatbotTestingContext = useContext(ChatbotTestingContext);
  const [showCreateSuiteCaseModal, setShowCreateSuiteCaseModal] = useState(false);
  const [newNameSuite, setNewNameSuite] = useState('');
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);

  const getSuiteCaseCurrentName = () => {
    const currentSuite = chatbotTestingContext.testCasesSuites.find((suite) => suite.current);
    if (currentSuite) return currentSuite.name;
    return null;
  };

  const handleSuiteOnChange = (e) => {
    if (e === getSuiteCaseCurrentName()) return null;
    chatbotTestingContext.changeCurrentTestCaseSuite(e);
  };

  const handleChangeNewNameSuite = (e) => {
    setNewNameSuite(e.target.value);
  };

  const handleCancelNewSuite = () => {
    setShowCreateSuiteCaseModal(false);
  };

  const handleConfirmNewSuite = () => {
    chatbotTestingContext.createTestCaseSuite(newNameSuite,
      () => setShowCreateSuiteCaseModal(false));
  };

  const handleNewSuite = () => {
    setNewNameSuite('');
    setShowCreateSuiteCaseModal(true);
  };

  const handleDeleteSuite = () => {
    setShowDeleteConfirmDialog(true);
  };

  return (
    <>

      {showDeleteConfirmDialog ? (
        <DeleteConfirmation
          title="Confirmação"
          content="Você confirma a exclusão desse conjunto de testes?"
          confirmationClick={chatbotTestingContext.deleteCurrentTestCaseSuite}
          cancelationClick={() => setShowDeleteConfirmDialog(false)}
        />
      ) : null}

      {showCreateSuiteCaseModal
        ? (
          <Scrim classes="is-foco">
            <Modal
              classes={styles.ModalNewSuite}
              title="Criação de novo conjunto de testes"
              content={(
                <Validation>
                  <Input
                    label="Nome:"
                    inline
                    width={400}
                    mandatory
                    value={newNameSuite}
                    onChange={handleChangeNewNameSuite}
                  />
                </Validation>
        )}
              buttons={(
                <>
                  <Button
                    classes="mr-1"
                    primary
                    small
                    onClick={handleConfirmNewSuite}
                    disabled={!newNameSuite}
                  >
                    <small>Criar</small>
                  </Button>
                  <Button
                    primary
                    small
                    onClick={handleCancelNewSuite}
                  >
                    <small>Cancelar</small>
                  </Button>
                </>
        )}
            />
          </Scrim>
        ) : null}
      <div className={styles.Suites}>
        <Select
          label="Conjunto de testes:"
          inline
          small
          labelWidth={130}
          placeholder="Selecione um conjunto"
          width={230}
          value={getSuiteCaseCurrentName()}
          onChange={handleSuiteOnChange}
        >
          {chatbotTestingContext.testCasesSuites.map((suite) => (
            <SelectOption selected={suite.current} key={suite.id}>
              {suite.name}
            </SelectOption>
          ))}
        </Select>
        <Button
          classes="ml-1"
          circle
          primary
          small
          onClick={handleNewSuite}
        >
          <i className="fa fa-plus" aria-hidden="true" />
        </Button>
        <Button
          classes="ml-1"
          circle
          primary
          small
          onClick={handleDeleteSuite}
        >
          <i className="fa fa-trash" aria-hidden="true" />
        </Button>
      </div>
    </>
  );
}
